/* =====================================================================
   HOMEPAGE — rumble-and-rest-homepage-final.html
   ---------------------------------------------------------------------
   The mock's script, with one change: reviews come from Shopify rather
   than a hand-edited array. The template writes the `custom.reviews`
   metafield of the featured product into window.__homeReviews, and the
   section is not rendered at all when that is empty — so the mock's
   DEV_PREVIEW notice ("No reviews entered yet…"), which exists to show
   the author the page rhythm while building, never reaches a shopper.

   Everything else — progress bar, scroll reveals, review carousel — is
   the mock's behaviour unchanged.
   ===================================================================== */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = $('.hp4');
  if (!root) return;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };

  /* ---------------- reading progress ---------------- */
  (function () {
    var bar = $('#progress', root);
    if (!bar || RM) return;
    var queued = false;
    function paint() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? Math.min(100, window.scrollY / h * 100) : 0) + '%';
      queued = false;
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }());

  /* ---------------- scroll reveals ---------------- */
  (function () {
    var items = $$('.rv', root);
    if (!items.length || !('IntersectionObserver' in window)) return;
    if (RM) { items.forEach(function (i) { i.classList.add('in'); }); return; }
    $$('[data-stagger]', root).forEach(function (g) {
      $$('.rv', g).forEach(function (c, i) { c.style.setProperty('--d', (i * 70) + 'ms'); });
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }());

  /* ---------------- reviews ---------------- */
  (function () {
    var track = $('#revTrack', root), nav = $('#revNav', root),
        prev = $('#revPrev', root), next = $('#revNext', root);
    if (!track) return;

    var data = Array.isArray(window.__homeReviews) ? window.__homeReviews : [];
    var live = data.filter(function (r) {
      return r && (String(r.text || '').trim() || String(r.title || '').trim() || String(r.image || '').trim());
    });
    /* The template does not render this section without reviews, so
       arriving here empty means bad data rather than no data. */
    if (!live.length) { if (nav) nav.style.display = 'none'; return; }

    track.innerHTML = live.map(function (r) {
      var n = Math.max(0, Math.min(5, parseInt(r.stars, 10) || 0));
      return '<article class="rev-card">' +
        (r.image ? '<div class="rev-photo"><img src="' + esc(r.image) + '" alt="" loading="lazy" decoding="async"></div>' : '') +
        '<div class="rev-body">' +
          '<div class="rev-stars" aria-label="Rated ' + n + ' out of 5">' +
            '★'.repeat(n) + '☆'.repeat(5 - n) + '</div>' +
          (r.title ? '<h3 class="rev-title">' + esc(r.title) + '</h3>' : '') +
          (r.text ? '<p class="rev-text">' + esc(r.text) + '</p>' : '') +
          '<div class="rev-meta">' +
            (r.name ? '<b>' + esc(r.name) + '</b>' : '') +
            (r.details ? '<span class="rev-details">' + esc(r.details) + '</span>' : '') +
            (r.date ? '<span class="date">' + esc(r.date) + '</span>' : '') +
            (r.verified ? '<span class="verified">✓ Verified purchase</span>' : '') +
          '</div>' +
        '</div></article>';
    }).join('');

    var cards = $$('.rev-card', track);
    function step(d) {
      var c = cards[0];
      if (!c) return;
      track.scrollBy({ left: d * (c.getBoundingClientRect().width + 14), behavior: RM ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });

    function sync() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf); raf = requestAnimationFrame(sync);
    }, { passive: true });
    sync();
    if (cards.length < 2 && nav) nav.style.display = 'none';
  }());
}());
